export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";